/**
 * Formats duration from seconds to human-readable format
 * @param durationInSeconds - Duration in seconds
 * @returns Formatted duration string (e.g., "2 hr 30 min", "45 min", "30 sec")
 * @example
 * formatDurationFromSecs(7830) // "2 hr 10 min"
 * formatDurationFromSecs(90) // "1 min"
 * formatDurationFromSecs(30) // "30 sec"
 */
export const formatDurationFromSecs = (durationInSeconds: number): string => {
  const hours = Math.floor(durationInSeconds / 3600);
  const minutes = Math.floor((durationInSeconds % 3600) / 60);

  let result = "";

  if (hours > 0) {
    result += `${hours} hr `;
  }

  if (minutes > 0) {
    result += `${minutes} min `;
  }

  if (hours === 0 && minutes === 0) {
    result += `${Math.ceil(durationInSeconds)} sec`;
  }

  return result.trim();
};

/**
 * Formats duration from minutes to human-readable format
 * @param durationInMinutes - Duration in minutes
 * @returns Formatted duration string (e.g., "2 hr 30 min", "45 min")
 * @example
 * formatDurationFromMins(150) // "2 hr 30 min"
 * formatDurationFromMins(45) // "45 min"
 */
export const formatDurationFromMins = (durationInMinutes: number): string => {
  const durationInSeconds = durationInMinutes * 60;
  const result = formatDurationFromSecs(durationInSeconds);
  return result.trim();
};
